import { Accordion } from '../../../../../components/general/accordion';
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation';
import { Grid } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { CasesGeneralInfoProps } from './props';
import dayjs from 'dayjs';
import DateTimePickerField from '../../../../../components/general/fields/dateTimePickerField';
import { useCasesGeneralInfo } from './hook';

export const CasesGeneralInfoData = ({
    casesGeneral,
}: CasesGeneralInfoProps) => {
    const {
        formik,
        getChannelName,
        getStatusName,
        getBranchName,
        getProductName,
        getTypificationNames,
        getOfficieName,
    } = useCasesGeneralInfo(casesGeneral);

    return (
        <Accordion
            title="CASO GENERAL"
            icon={<InsertInvitationIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="ID caso"
                        name="idCaso"
                        size="small"
                        // value={formik.values.createdBy}
                        // onChange={console.log}
                    />
                </Grid>

                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Call ID"
                        name="callId"
                        size="small"
                        value={formik.values.callId}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Canal"
                        name="channel"
                        size="small"
                        value={getChannelName()}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Estado"
                        name="status"
                        size="small"
                        value={getStatusName()}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FieldText
                        label="Tipificación"
                        name="typification"
                        size="small"
                        value={getTypificationNames()}
                        rows={3}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Poliza"
                        name="police"
                        size="small"
                        value={formik.values.policie || ''}
                        rows={3}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Producto"
                        name="product"
                        size="small"
                        value={getProductName()}
                        rows={3}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Oficina"
                        name="officie"
                        size="small"
                        value={getOfficieName()}
                        rows={3}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Sucursal"
                        name="branch"
                        size="small"
                        value={getBranchName()}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Placa"
                        name="plate"
                        size="small"
                        value={formik.values.plate || ''}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <DateTimePickerField
                        label="Fecha del evento"
                        name="createdAt"
                        size="small"
                        value={
                            formik.values.dateEvent
                                ? dayjs(formik.values.dateEvent)
                                : null
                        }
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Radicado de correspondencia"
                        name="correspondenceFiling"
                        size="small"
                        value={formik.values.correspondenceFiling || ''}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FieldText
                        label="Descripción de los hechos"
                        name="branch"
                        size="small"
                        value={formik.values.description || ''}
                        rows={3}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FieldText
                        label="Observación"
                        name="branch"
                        size="small"
                        value={formik.values.observation || ''}
                        rows={3}
                    />
                </Grid>
            </Grid>
        </Accordion>
    );
};
